module.exports = __webpack_public_path__ + "img/about-m-slide-28.b08f324e.jpg";